import { useMemo } from 'react';
import { ContentTypeFieldResponse } from '../../../../Model/responseDtos/ContentTypeFieldResponse';
import { MainDocContentTypeResponse } from '../../../../Model/responseDtos/MainDocContentTypeResponse';

interface UseFileUploadConfigParams {
  contentType: MainDocContentTypeResponse | undefined;
  ctFields: ContentTypeFieldResponse[];
  multiFileUploadLimit: number | undefined;
}

interface UseFileUploadConfigReturn {
  allowsMultiFileUpload: boolean;
  perFileFields: ContentTypeFieldResponse[];
  maxFiles: number | undefined;
  needsToRenderFilesInTable: boolean;
}

export const useFileUploadConfig = ({
  contentType,
  ctFields,
  multiFileUploadLimit
}: UseFileUploadConfigParams): UseFileUploadConfigReturn => {
  const allowsMultiFileUpload = contentType?.multiFileUpload === true;

  const perFileFields = useMemo(() => {
    if (!allowsMultiFileUpload) {
      return [];
    }
    return ctFields.filter(f => f.fileDependent === true);
  }, [ctFields, allowsMultiFileUpload]);

  const maxFiles = allowsMultiFileUpload ? multiFileUploadLimit : undefined;
  const needsToRenderFilesInTable = allowsMultiFileUpload && perFileFields.length > 0;

  return {
    allowsMultiFileUpload,
    perFileFields,
    maxFiles,
    needsToRenderFilesInTable
  };
};
